import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import CategoryPill from 'components/category-pill/CategoryPill';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './profile-card-group.scss';

import type { ProfileCardGroupIcon } from './types';

interface Item {
  identifier: string,
  label: string
}

interface Props {
  identifier: string,
  items?: Array<Item> | null,
  label: {
    value: string,
    popover?: React.ReactNode,
    icon?: ProfileCardGroupIcon
  }
}

const ProfileCardGroup: React.FC<Props> = ({
  identifier,
  label,
  items
}): JSX.Element => {
  const icon = label.icon;

  const renderIcon = (
    iconInfo: ProfileCardGroupIcon
  ): React.ReactNode => (
    <div className="profile-card-group__label-icon">
      <SVGDynamicIcon
        name={iconInfo.name}
        width={iconInfo.width}
        height={iconInfo.height}
        customColor={iconInfo.color ?? 'black'}
        className={iconInfo.className}
      />
    </div>
  );

  const renderLabelPopover = (): React.ReactNode => (
    <div className="profile-card-group__label-popover">
      {label.popover}
    </div>
  );

  const renderItems = (): React.ReactNode => (
    <div className="profile-card-group__items">
      {
        (items || []).map(item => (
          <CategoryPill
            key={`profile-card-group--${identifier}-${item.identifier}`}
            label={item.label}
          />
        ))
      }
    </div>
  );

  return (
    <div className="profile-card-group">
      <div className="profile-card-group__label">
        {!isNil(icon) && renderIcon(icon)}
        <div className="profile-card-group__label-value">
          {label.value}
        </div>
        {!isNil(label.popover) && renderLabelPopover()}
      </div>
      {!isEmpty(items) && renderItems()}
    </div>
  );
};

export default ProfileCardGroup;
